// keepEmptyStringKeys: keys (at any depth) whose empty-string value is an explicit
// "clear this field" signal from the caller and must survive cleaning.
export function clean(testIn: Record<string, any>, keepEmptyStringKeys: string[] = []) {
  const test = testIn;
  for (const i in test) {
    if (test[`${i}ActiveStatus`] === false) {
      test[i] = null;
    } else if (test[i] === null || test[i] === undefined || (test[i] === '' && !keepEmptyStringKeys.includes(i))) {
      delete test[i];
    } else if (typeof test[i] === 'object') {
      clean(test[i], keepEmptyStringKeys);
    }
  }
  return test;
}
